import React from 'react';
import { CheckboxField } from '@trp-beacon-ui-kit/react-controls';
import styles from './RPSOCRConsentAndAgreement.css';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import { ocrConsentAgreementText } from './utils';

const RPSOCRConsentAndAgreement = ({
  consentAgreement,
  setConsentAgreement,
  accountType
}) => {
  const ocrConsentAgreementStatement = ocrConsentAgreementText(accountType);
  return (
    <div>
      <div className="section-header">
        <SectionHeading text="Consent and Agreement" />
      </div>
      <div className="section-content">
        <div className="consent-header">
          The following will be read to the client prior to submitting the
          new account set up. 
        </div>
        {ocrConsentAgreementStatement &&
          ocrConsentAgreementStatement.map(item => (
            <div
              key={`consent-para-${Math.random()}`}
              className="consent-info-text">
              {item}
            </div>
          ))}
        <div className="consent-agree">
          <div className="consent-text">
            Please select &quot;Client Agrees&quot; to continue.
          </div>
          <div className="checkbox-container">
            <CheckboxField
              title={<div className="cell">Client Agrees</div>}
              onChange={() => setConsentAgreement(!consentAgreement)}
            />
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RPSOCRConsentAndAgreement;
